"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROMOCODE_LOGIC_TYPE = void 0;
exports.PROMOCODE_LOGIC_TYPE = {
    PERCENT_DISCOUNT_FOR_ALL_PRODUCT_TYPES: 'PERCENT_DISCOUNT_FOR_ALL_PRODUCT_TYPES',
    PERCENT_DISCOUNT_FROM_SUBTOTAL: 'PERCENT_DISCOUNT_FROM_SUBTOTAL',
    FIXED_DISCOUNT_FROM_SUBTOTAL: 'FIXED_DISCOUNT_FROM_SUBTOTAL',
    PERCENT_DISCOUNT_FOR_ONE_PRODUCT_TYPE: 'PERCENT_DISCOUNT_FOR_ONE_PRODUCT_TYPE',
    FREE_SHIPPING: 'FREE_SHIPPING'
};
//# sourceMappingURL=promocodeLogicType.js.map